/** Shared look for the Ask AI, Multi-AI and Legal Compliance chat pages. */
export const CHAT_COLORS = {
  brand: "#005EB8",
  text: "#0F172A",
  body: "#1E293B",
  muted: "#64748B",
  subtle: "#94A3B8",
  border: "#E2E8F0",
  hoverBg: "#F5F9FF",
  userBubble: "#EEF4FB",
};

/** The app font; drawers render in a portal outside the element that sets it */
export const CHAT_FONT = "'Noto Sans KR', sans-serif";

/** Readable column width for messages and the input */
export const CHAT_COLUMN_MAX_W = "860px";

/**
 * Chat-sized typography for answers rendered by MarkdownContent. The global
 * `.htmltargeted` rules are sized for documents (h1 34px, table cells 16px).
 */
export const chatMarkdownSx = {
  ".htmltargeted": {
    fontSize: "15px",
    lineHeight: 1.7,
    color: CHAT_COLORS.body,
    wordBreak: "break-word",
  },
  ".htmltargeted p": { margin: "0 0 10px" },
  ".htmltargeted p:last-child": { marginBottom: 0 },
  ".htmltargeted h1, .htmltargeted h2": {
    fontSize: "18px",
    lineHeight: 1.4,
    color: CHAT_COLORS.text,
    margin: "18px 0 8px",
  },
  ".htmltargeted h3, .htmltargeted h4, .htmltargeted h5": {
    fontSize: "16px",
    lineHeight: 1.4,
    color: CHAT_COLORS.text,
    margin: "14px 0 6px",
  },
  ".htmltargeted > *:first-child": { marginTop: 0 },
  ".htmltargeted ul, .htmltargeted ol": { paddingLeft: "22px", margin: "4px 0 10px" },
  ".htmltargeted li": { margin: "4px 0" },
  ".htmltargeted strong": { color: CHAT_COLORS.text, fontWeight: 600 },
  ".htmltargeted a": { color: CHAT_COLORS.brand, textDecoration: "none" },
  ".htmltargeted a:hover": { textDecoration: "underline" },
  ".htmltargeted table": { fontSize: "14px", margin: "8px 0 12px" },
  ".htmltargeted th": { fontSize: "14px", padding: "6px 10px" },
  ".htmltargeted td": { fontSize: "14px", padding: "6px 10px", borderColor: CHAT_COLORS.border },
};
